import { SetupAuth } from "../../client";

const sourceParam = (isInForce?: boolean) => (isInForce ? "force" : "rc");

export const getTabId = async (
  tabIdForm: string,
  authorization: string,
  ambient: string,
  setTabName: React.Dispatch<React.SetStateAction<string>>,
  isInForce?: boolean,
  skillIdForm?: string,
) => {
  try {
    const apiClient = SetupAuth(authorization);
    const source = sourceParam(isInForce);
    const params = new URLSearchParams({ ambient, source });
    if (isInForce && skillIdForm && skillIdForm.trim() !== "") {
      params.set("skillId", skillIdForm);
    } else if (tabIdForm && tabIdForm.trim() !== "") {
      params.set("tabId", tabIdForm);
    } else {
      return;
    }
    const response = await apiClient.get(`/get-tab?${params.toString()}`);
    setTabName(response.data.name);
    return response.data;
  } catch {
    return;
  }
};

export const getTabIdForce = async (
  tabIdForm: string,
  authorization: string,
  ambient: string,
  setTabName: React.Dispatch<React.SetStateAction<string>>,
) => {
  return getTabId(tabIdForm, authorization, ambient, setTabName, true);
};